import React from "react";
import { Paper } from "@mui/material";
import { C, LAYOUT } from "../constants/colors";

export default function Card({ children, style = {}, sx = {} }) {
  return (
    <Paper
      variant="outlined"
      style={style}
      sx={{
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: `${LAYOUT.radius}px`,
        p: { xs: 2.5, md: 3 },
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}
